<template>
  <div class="layout-topbar layout-topbar-public">
    <div class="p-grid p-justify-between">
      <img
        src="assets/layout/images/grsmlogo_blanco.png"
        alt="logo de gobierno regional"
        class="mt-1"
        style="height: 60px; width: 230px"
      />
      <img
        src="assets/layout/images/GSObservatorio.png"
        alt=""
        class="mt-2"
        style="height: 50px; width: 300px"
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>
